export default "__VITE_ASSET__716ea88e__"